/* src/app/components/shared/molecules/confirmation-dialog/confirmation-dialog.component.scss */
:host {
  display: block;
}
mat-dialog-content {
  margin-bottom: var(--sizes-spacing-4);
}
mat-dialog-actions {
  padding-bottom: var(--sizes-spacing-4);
  padding-right: var(--sizes-spacing-4);
}
button + button {
  margin-left: var(--sizes-spacing-2);
}
/*# sourceMappingURL=confirmation-dialog.component-5VTZQS2D.css.map */
